export const useUrlParams = (url?: string) => {
  const getParam = (param: string) => {
    const params = new URLSearchParams(decodeURI(url || ''));
    return decodeURIComponent(params.get(param) ?? '');
  };

  return {
    getParam,
  };
};
